import { render, staticRenderFns } from "./OcPendienteAct.vue?vue&type=template&id=27e4de0d&scoped=true"
import script from "./OcPendienteAct.vue?vue&type=script&lang=js"
export * from "./OcPendienteAct.vue?vue&type=script&lang=js"
import style0 from "./OcPendienteAct.vue?vue&type=style&index=0&id=27e4de0d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e4de0d",
  null
  
)

export default component.exports